import { render } from "./userManagement.vue?vue&type=template&id=a1c6fa14&scoped=true"
import script from "./userManagement.vue?vue&type=script&lang=js"
export * from "./userManagement.vue?vue&type=script&lang=js"

import "./userManagement.vue?vue&type=style&index=0&id=a1c6fa14&lang=scss&scoped=true"
import "./userManagement.vue?vue&type=style&index=1&id=a1c6fa14&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1c6fa14"]])

export default __exports__